Bingo.OfferFilterFormProperty = {};

Bingo.OfferFilterFormProperty.init = function () {
    const select = $('[data-select-placeholder] select');
    const optionSelected = select.find(':selected').attr('value');
    if (optionSelected === 'not-selected') {
        select.addClass('placeholder-active');
    } else {
        select.removeClass('placeholder-active');
    }
};
